const initialState = {
    orders: [], // Initialize with an empty array
    orderNumber: 1
};

const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ORDERS":
            return { ...state, orders: action.orders }; // Update orders data
        case "SET_ORDER_NUMBER":
            return { ...state, orderNumber: action.orderNumber }; // Update orderNumber
        case "GET_ORDER_NUMBER":
            return { ...state, orderNumber: action.orderNumber }; // Get orderNumber
        case "GET_ORDERS":
            return { ...state, orders: action.orders }; // Get orders data
        default:
            return state; // Return the previous state for all other actions
    }
};

export default ordersReducer;